import * as React from 'react'

import {cn} from '@/lib/utils'

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
    className?: string
    type?: React.HTMLInputTypeAttribute
    showValidCheck?: boolean
    'data-testid'?: string | undefined
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({className, type = 'text', showValidCheck, 'data-testid': dataTestId, ...props}, ref) => {
        const styleObj = showValidCheck
            ? {
                  backgroundImage: `url('data:image/svg+xml,<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="15px" height="15px" viewBox="2.5 2.5 15 15" enable-background="new 2.5 2.5 15 15" xml:space="preserve"><g><path fill="%23178938" d="M8.375,10.959l5.38-5.459L15.5,7.27L8.375,14.5L4.5,10.564l1.746-1.769L8.375,10.959z"/></g></svg>')`,
                  backgroundColor: 'transparent'
              }
            : {}

        return (
            <input
                type={type}
                className={cn(
                    'relative h-[3.1875rem] pl-2.5 pr-9 pt-[1.5625rem] pb-0 font-grotesque font-light body-md border-0 border-b border-solid border-btn-secondary-text rounded-none bg-transparent focus-visible:outline-none focus-visible:shadow-[0_1px_5px_0_rgba(55,_84,_129,_0.5)] focus-visible:border focus-visible:border-primary-focus-shadow focus-visible:border-b-[#7493c4] focus-visible:rounded-[6px_6px_0_0]',
                    showValidCheck &&
                        'bg-no-repeat bg-[length:1.125rem_1.125rem] bg-[top_1rem_right_1.5625rem]',
                    className
                )}
                style={styleObj}
                ref={ref}
                data-testid={dataTestId || 'Input'}
                {...props}
            />
        )
    }
)
Input.displayName = 'Input'

export {Input}
